module.exports = __webpack_public_path__ + "img/p2.4eeec3b1.png";